var exports = {
  "DD": "title__SYIFnp",
  "yu": "metadata__VKbB2B",
  "az": "Box__Yu_-er",
  "wy": "Box_1__JlBmrQ",
};

module.exports = exports;
